enum ChargingModeColumnIntl {
    CLIMATE_CONTROL_ENABLED = 'e4c.vehicles.charging.climateControl',
    CLIMATE_CONTROL_DISABLED = 'e4c.vehicles.charging.noClimateControl',
    IMMEDIATE_CHARGING_MODE = 'e4c.vehicles.charging.immediate',
    PROGRAMMED_CHARGING_MODE = 'e4c.vehicles.charging.programmed.short',
    SENDING_CONFIGURATION = 'e4c.vehicles.charging.sending',
}

export default ChargingModeColumnIntl;
